/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { EduContentProductTypeInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class EduContentProductTypeApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'EduContentProductTypes');
  }

  find(params?): Observable<EduContentProductTypeInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<EduContentProductTypeInterface[]>(path, httpParams);
  }

  getEduContentProductTypes(
    params: HttpParams
  ): Observable<{ count: number; results: EduContentProductTypeInterface[] }> {
    return this.get('search', params);
  }

  createEduContentProductType(
    eduContentProductType: EduContentProductTypeInterface
  ): Observable<EduContentProductTypeInterface> {
    const path = '';
    return this.post(path, undefined, eduContentProductType);
  }

  updateEduContentProductType(
    params: HttpParams,
    eduContentProductType: EduContentProductTypeInterface
  ): Observable<EduContentProductTypeInterface> {
    const path = '';
    return this.put(path, params, eduContentProductType);
  }

  deleteById(id: number): Observable<boolean> {
    const path = `${id}`;
    return this.delete<void>(path).pipe(map(() => true));
  }
}
